<div class="content-wrapper">
	<div class="content-wrapper">
		<div class="content-body">

			<!-- content-header component -->
			<app-content-header [contentHeader]="contentHeader"></app-content-header>

			<div class="card">

				<!-- TABELA DE DADOS -->
				<section id="ngx-datatable-inline-editing">
					<!-- FUNCOES DA TABELA -->
					<div class="row">
						<div class="col-12">
							<button class="btn btn-primary float-right mr-1 mt-1" routerLink="/pedido/cadastro/faleflex"
								rippleEffect>
								<i data-feather="plus" class="mr-0 mr-sm-1"></i><span
									class="d-none d-sm-inline-block">Novo <b>pedido</b></span>
							</button>
							<!-- <a csvLink [data]="exportCSVData" class="btn btn-outline-secondary float-right mr-1 mt-1" rippleEffect>Exportar
                                        CSV</a> -->
						</div>
					</div>
					<hr>
					<!-- FILTROS DA TABELA -->
					<div class="row">
						<div class="col-md-6 col-12">
							<div class="d-flex justify-content-between align-items-center m-1">
								<label class="d-flex align-items-center">Mostrar
									<select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
										<option value="10">10</option>
										<option value="25">25</option>
										<option value="50">50</option>
										<option value="100">100</option>
									</select>
								</label>
							</div>
						</div>
					</div>

					<!-- DATATABLE -->
					<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
						[reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
						[loadingIndicator]="starting" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

						<!-- COLUNA -->
						<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>N. Pedido</h4>
								<input type="search" placeholder="N. Pedido" class="ml-25 form-control"
									(keyup)="numPedidoFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.num_pedido}}</span>
							</ng-template>
						</ngx-datatable-column>
						
						<!-- COLUNA -->
						<ngx-datatable-column name="CPF/CNPJ" prop="cpf_cnpj" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>CPF/CNPJ</h4>
								<input type="search" placeholder="CPF/CNPJ" class="ml-25 form-control"
									(keyup)="cpfFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.cpf_cnpj}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA -->
						<ngx-datatable-column name="Cliente" prop="nome_fantasia" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Cliente</h4>
								<input type="search" placeholder="N. Pedido" class="ml-25 form-control"
									(keyup)="nomeFantasiaFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span title="{{row.nome_fantasia}}" class="font-weight-bold">{{row.nome_fantasia}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA -->
						<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Status</h4>
								<!-- <input type="search" placeholder="Pesquisar Nome" class="ml-25 form-control"
									(keyup)="statusFilter($event)" /> -->
								<select [(ngModel)]="selectedStatus" (change)="statusFilter()"
									class="ml-25 form-control" name="" id="">
									<option [value]="0">Todos</option>
									<option [value]="1">Aguardando Contrato</option>
									<option [value]="2">Contrato Gerado</option>
									<option [value]="3">Cancelado</option>
								</select>
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="badge badge-pill badge-light-warning" *ngIf="row.id_status == 1">Aguardando
									Contrato</span>
								<span class="badge badge-pill badge-light-success" *ngIf="row.id_status == 2">Contrato
									Gerado</span>
								<span class="badge badge-pill badge-light-danger" *ngIf="row.id_status == 3">Cancelado</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA -->
						<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
							<ng-template let-column="column" ngx-datatable-header-template>
								<h4>Data do pedido</h4>
								<input type="search" placeholder="Pesquisar Fim" class="ml-25 form-control"
									mask="00/00/0000" (keyup)="dateFilter($event)" />
							</ng-template>
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<span class="font-weight-bold">{{row.dt_pedido | date:'dd/MM/yyyy HH:mm':'UTC'}}</span>
							</ng-template>
						</ngx-datatable-column>

						<!-- COLUNA -->
						<ngx-datatable-column [width]="20" [sortable]="false">
							<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
								let-row="row">
								<div class="d-flex align-items-center" style="float: right">
									<div ngbDropdown container="body">
										<a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
											id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
											aria-expanded="false">
											<i data-feather="more-vertical"
												class="text-primary cursor-pointer mr-50"></i>
										</a>
										<div ngbDropdownMenu class="dropdown-menu-right"
											aria-labelledby="dropdownBrowserState">
											<a routerLink="/pedido/gerenciar/faleflex/{{row.id_pedido}}" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="settings"
													class="mr-50"></i> Gerenciar</a>
											<!-- <a (click)="confirmDeleteAlert(row.id_sistema)" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="trash-2"
													class="mr-50"></i> Excluir</a> -->
										</div>
									</div>
								</div>
							</ng-template>
						</ngx-datatable-column>

					</ngx-datatable>
				</section>

			</div>
		</div>
	</div>